import { j as w, c as x } from "../../utils-BdNIfrGQ.js";
import * as P from "react";
import { useState as Y, useMemo as ve, useCallback as _e, isValidElement as Be } from "react";
import { c as T } from "../../index-Di82Y7n3.js";
import { D as Ve } from "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { u as ke } from "../../ResponsiveProvider-BC7BKjLV.js";
import { T as qe } from "../../Text-BhLXzYEf.js";
import { c as Ue } from "../../createLucideIcon-D4r5Phnh.js";
import { A as Ke, a as Xe } from "../../arrow-up-AnRP2l0q.js";
import Je from "../scroll-shadow/ScrollShadow.mjs";
import { S as Fe } from "../../skeleton-CpjuZTJp.js";
const Qe = [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
], We = Ue("move-vertical", Qe), de = P.forwardRef(
  ({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx("table", { ref: t, className: x("table w-full caption-bottom text-sm", e), ...o })
);
de.displayName = "Table";
const ce = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx("thead", { ref: t, className: x("[&_tr]:border-b", e), ...o }));
ce.displayName = "TableHeader";
const fe = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx("tbody", { ref: t, className: x("[&_tr:last-child]:border-0", e), ...o }));
fe.displayName = "TableBody";
const Ye = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx(
  "tfoot",
  {
    ref: t,
    className: x("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
    ...o
  }
));
Ye.displayName = "TableFooter";
const N = P.forwardRef(
  ({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx(
    "tr",
    {
      ref: t,
      className: x(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...o
    }
  )
);
N.displayName = "TableRow";
const pe = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx(
  "th",
  {
    ref: t,
    className: x(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...o
  }
));
pe.displayName = "TableHead";
const me = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx(
  "td",
  {
    ref: t,
    className: x("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...o
  }
));
me.displayName = "TableCell";
const Ze = P.forwardRef(({ className: e, ...o }, t) => /* @__PURE__ */ w.jsx("caption", { ref: t, className: x("mt-4 text-sm text-muted-foreground", e), ...o }));
Ze.displayName = "TableCaption";
const be = T("border border-gray-400 rounded-lg relative", {
  variants: {
    loading: {
      true: "pointer-events-none opacity-70"
    }
  },
  defaultVariants: {
    loading: !1
  }
}), Me = T(
  "w-full [&_tbody_tr]:bg-white [&_tbody_tr]:border-b [&_tbody_tr]:border-gray-400",
  {
    variants: {
      sortable: {
        true: "[&_th:not(.parent)]:cursor-pointer"
      }
    },
    defaultVariants: {
      sortable: !1
    }
  }
), ye = T(
  "py-5 pl-6 pr-6 border-b border-gray-400 bg-white [&>span]:flex [&>span]:items-center [&>span]:gap-2 [&>span]:text-gray-700",
  {
    variants: {
      empty: {
        true: "border-b bg-gray-200 pointer-events-none"
      },
      parent: {
        true: "border-r border-l parent"
      },
      highlighted: {
        true: "bg-primary/10 text-primary font-semibold"
      },
      first: {
        true: "border-l"
      },
      last: {
        true: "border-r"
      }
    }
  }
), Pe = T(
  "[&.kraken-table-cell]:min-h-[65px] [&.kraken-table-cell]:px-6 whitespace-nowrap text-lg lg:text-base"
), Z = T("text-gray-700 ml-3", {
  variants: {
    isSorted: {
      true: "text-primary"
    }
  }
});
function et() {
  return {
    accessor: (e, o) => typeof e == "function" ? {
      ...o,
      accessorFn: e
    } : {
      ...o,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function G(e, o) {
  return typeof e == "function" ? e(o) : e;
}
function V(e, o) {
  return (t) => {
    o.setState((n) => ({
      ...n,
      [e]: G(t, n[e])
    }));
  };
}
function Q(e) {
  return e instanceof Function;
}
function tt(e) {
  return Array.isArray(e) && e.every((o) => typeof o == "number");
}
function nt(e, o) {
  const t = [], n = (r) => {
    r.forEach((i) => {
      t.push(i);
      const l = o(i);
      l != null && l.length && n(l);
    });
  };
  return n(e), t;
}
function S(e, o, t) {
  let n = [], r;
  return (i) => {
    let l;
    t.key && t.debug && (l = Date.now());
    const s = e(i);
    if (!(s.length !== n.length || s.some((d, m) => n[m] !== d)))
      return r;
    n = s;
    let a;
    if (t.key && t.debug && (a = Date.now()), r = o(...s), t == null || t.onChange == null || t.onChange(r), t.key && t.debug && t != null && t.debug()) {
      const d = Math.round((Date.now() - l) * 100) / 100, m = Math.round((Date.now() - a) * 100) / 100, c = m / 16, g = (f, p) => {
        for (f = String(f); f.length < p; )
          f = " " + f;
        return f;
      };
      console.info(`%c⏱ ${g(m, 5)} /${g(d, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * c, 120))}deg 100% 31%);`, t?.key);
    }
    return r;
  };
}
function C(e, o, t, n) {
  return {
    debug: () => {
      var r;
      return (r = e?.debugAll) != null ? r : e[o];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: n
  };
}
function ot(e, o, t, n) {
  const r = () => {
    var l;
    return (l = i.getValue()) != null ? l : e.options.renderFallbackValue;
  }, i = {
    id: `${o.id}_${t.id}`,
    row: o,
    column: t,
    getValue: () => o.getValue(n),
    renderValue: r,
    getContext: S(() => [e, t, o, i], (l, s, u, a) => ({
      table: l,
      column: s,
      row: u,
      cell: a,
      getValue: a.getValue,
      renderValue: a.renderValue
    }), C(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((l) => {
    l.createCell == null || l.createCell(i, t, o, e);
  }, {}), i;
}
function rt(e, o, t, n) {
  var r, i;
  const s = {
    ...e._getDefaultColumnDef(),
    ...o
  }, u = s.accessorKey;
  let a = (r = (i = s.id) != null ? i : u ? typeof String.prototype.replaceAll == "function" ? u.replaceAll(".", "_") : u.replace(/\./g, "_") : void 0) != null ? r : typeof s.header == "string" ? s.header : void 0, d;
  if (s.accessorFn ? d = s.accessorFn : u && (u.includes(".") ? d = (c) => {
    let g = c;
    for (const p of u.split(".")) {
      var f;
      g = (f = g) == null ? void 0 : f[p], process.env.NODE_ENV !== "production" && g === void 0 && console.warn(`"${p}" in deeply nested key "${u}" returned undefined.`);
    }
    return g;
  } : d = (c) => c[s.accessorKey]), !a)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let m = {
    id: `${String(a)}`,
    accessorFn: d,
    parent: n,
    depth: t,
    columnDef: s,
    columns: [],
    getFlatColumns: S(() => [!0], () => {
      var c;
      return [m, ...(c = m.columns) == null ? void 0 : c.flatMap((g) => g.getFlatColumns())];
    }, C(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: S(() => [e._getOrderColumnsFn()], (c) => {
      var g;
      if ((g = m.columns) != null && g.length) {
        let f = m.columns.flatMap((p) => p.getLeafColumns());
        return c(f);
      }
      return [m];
    }, C(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const c of e._features)
    c.createColumn == null || c.createColumn(m, e);
  return m;
}
const F = "debugHeaders";
function $e(e, o, t) {
  var n;
  let i = {
    id: (n = t.id) != null ? n : o.id,
    column: o,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const l = [], s = (u) => {
        u.subHeaders && u.subHeaders.length && u.subHeaders.map(s), l.push(u);
      };
      return s(i), l;
    },
    getContext: () => ({
      table: e,
      header: i,
      column: o
    })
  };
  return e._features.forEach((l) => {
    l.createHeader == null || l.createHeader(i, e);
  }), i;
}
const it = {
  createTable: (e) => {
    e.getHeaderGroups = S(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (o, t, n, r) => {
      var i, l;
      const s = (i = n?.map((m) => t.find((c) => c.id === m)).filter(Boolean)) != null ? i : [], u = (l = r?.map((m) => t.find((c) => c.id === m)).filter(Boolean)) != null ? l : [], a = t.filter((m) => !(n != null && n.includes(m.id)) && !(r != null && r.includes(m.id)));
      return K(o, [...s, ...a, ...u], e);
    }, C(e.options, F, "getHeaderGroups")), e.getCenterHeaderGroups = S(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (o, t, n, r) => (t = t.filter((i) => !(n != null && n.includes(i.id)) && !(r != null && r.includes(i.id))), K(o, t, e, "center")), C(e.options, F, "getCenterHeaderGroups")), e.getLeftHeaderGroups = S(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (o, t, n) => {
      var r;
      const i = (r = n?.map((l) => t.find((s) => s.id === l)).filter(Boolean)) != null ? r : [];
      return K(o, i, e, "left");
    }, C(e.options, F, "getLeftHeaderGroups")), e.getRightHeaderGroups = S(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (o, t, n) => {
      var r;
      const i = (r = n?.map((l) => t.find((s) => s.id === l)).filter(Boolean)) != null ? r : [];
      return K(o, i, e, "right");
    }, C(e.options, F, "getRightHeaderGroups")), e.getFooterGroups = S(() => [e.getHeaderGroups()], (o) => [...o].reverse(), C(e.options, F, "getFooterGroups")), e.getLeftFooterGroups = S(() => [e.getLeftHeaderGroups()], (o) => [...o].reverse(), C(e.options, F, "getLeftFooterGroups")), e.getCenterFooterGroups = S(() => [e.getCenterHeaderGroups()], (o) => [...o].reverse(), C(e.options, F, "getCenterFooterGroups")), e.getRightFooterGroups = S(() => [e.getRightHeaderGroups()], (o) => [...o].reverse(), C(e.options, F, "getRightFooterGroups")), e.getFlatHeaders = S(() => [e.getHeaderGroups()], (o) => o.map((t) => t.headers).flat(), C(e.options, F, "getFlatHeaders")), e.getLeftFlatHeaders = S(() => [e.getLeftHeaderGroups()], (o) => o.map((t) => t.headers).flat(), C(e.options, F, "getLeftFlatHeaders")), e.getCenterFlatHeaders = S(() => [e.getCenterHeaderGroups()], (o) => o.map((t) => t.headers).flat(), C(e.options, F, "getCenterFlatHeaders")), e.getRightFlatHeaders = S(() => [e.getRightHeaderGroups()], (o) => o.map((t) => t.headers).flat(), C(e.options, F, "getRightFlatHeaders")), e.getCenterLeafHeaders = S(() => [e.getCenterFlatHeaders()], (o) => o.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), C(e.options, F, "getCenterLeafHeaders")), e.getLeftLeafHeaders = S(() => [e.getLeftFlatHeaders()], (o) => o.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), C(e.options, F, "getLeftLeafHeaders")), e.getRightLeafHeaders = S(() => [e.getRightFlatHeaders()], (o) => o.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), C(e.options, F, "getRightLeafHeaders")), e.getLeafHeaders = S(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (o, t, n) => {
      var r, i, l, s, u, a;
      return [...(r = (i = o[0]) == null ? void 0 : i.headers) != null ? r : [], ...(l = (s = t[0]) == null ? void 0 : s.headers) != null ? l : [], ...(u = (a = n[0]) == null ? void 0 : a.headers) != null ? u : []].map((d) => d.getLeafHeaders()).flat();
    }, C(e.options, F, "getLeafHeaders"));
  }
};
function K(e, o, t, n) {
  var r, i;
  let l = 0;
  const s = function(c, g) {
    g === void 0 && (g = 1), l = Math.max(l, g), c.filter((f) => f.getIsVisible()).forEach((f) => {
      var p;
      (p = f.columns) != null && p.length && s(f.columns, g + 1);
    }, 0);
  };
  s(e);
  let u = [];
  const a = (c, g) => {
    const f = {
      depth: g,
      id: [n, `${g}`].filter(Boolean).join("_"),
      headers: []
    }, p = [];
    c.forEach((R) => {
      const h = [...p].reverse()[0], v = R.column.depth === f.depth;
      let _, M = !1;
      if (v && R.column.parent ? _ = R.column.parent : (_ = R.column, M = !0), h && h?.column === _)
        h.subHeaders.push(R);
      else {
        const $ = $e(t, _, {
          id: [n, g, _.id, R?.id].filter(Boolean).join("_"),
          isPlaceholder: M,
          placeholderId: M ? `${p.filter((E) => E.column === _).length}` : void 0,
          depth: g,
          index: p.length
        });
        $.subHeaders.push(R), p.push($);
      }
      f.headers.push(R), R.headerGroup = f;
    }), u.push(f), g > 0 && a(p, g - 1);
  }, d = o.map((c, g) => $e(t, c, {
    depth: l,
    index: g
  }));
  a(d, l - 1), u.reverse();
  const m = (c) => c.filter((f) => f.column.getIsVisible()).map((f) => {
    let p = 0, R = 0, h = [0];
    f.subHeaders && f.subHeaders.length ? (h = [], m(f.subHeaders).forEach((_) => {
      let {
        colSpan: M,
        rowSpan: $
      } = _;
      p += M, h.push($);
    })) : p = 1;
    const v = Math.min(...h);
    return R = R + v, f.colSpan = p, f.rowSpan = R, {
      colSpan: p,
      rowSpan: R
    };
  });
  return m((r = (i = u[0]) == null ? void 0 : i.headers) != null ? r : []), u;
}
const lt = (e, o, t, n, r, i, l) => {
  let s = {
    id: o,
    index: n,
    original: t,
    depth: r,
    parentId: l,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (u) => {
      if (s._valuesCache.hasOwnProperty(u))
        return s._valuesCache[u];
      const a = e.getColumn(u);
      if (a != null && a.accessorFn)
        return s._valuesCache[u] = a.accessorFn(s.original, n), s._valuesCache[u];
    },
    getUniqueValues: (u) => {
      if (s._uniqueValuesCache.hasOwnProperty(u))
        return s._uniqueValuesCache[u];
      const a = e.getColumn(u);
      if (a != null && a.accessorFn)
        return a.columnDef.getUniqueValues ? (s._uniqueValuesCache[u] = a.columnDef.getUniqueValues(s.original, n), s._uniqueValuesCache[u]) : (s._uniqueValuesCache[u] = [s.getValue(u)], s._uniqueValuesCache[u]);
    },
    renderValue: (u) => {
      var a;
      return (a = s.getValue(u)) != null ? a : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => nt(s.subRows, (u) => u.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let u = [], a = s;
      for (; ; ) {
        const d = a.getParentRow();
        if (!d) break;
        u.push(d), a = d;
      }
      return u.reverse();
    },
    getAllCells: S(() => [e.getAllLeafColumns()], (u) => u.map((a) => ot(e, s, a, a.id)), C(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: S(() => [s.getAllCells()], (u) => u.reduce((a, d) => (a[d.column.id] = d, a), {}), C(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let u = 0; u < e._features.length; u++) {
    const a = e._features[u];
    a == null || a.createRow == null || a.createRow(s, e);
  }
  return s;
}, st = {
  createColumn: (e, o) => {
    e._getFacetedRowModel = o.options.getFacetedRowModel && o.options.getFacetedRowModel(o, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : o.getPreFilteredRowModel(), e._getFacetedUniqueValues = o.options.getFacetedUniqueValues && o.options.getFacetedUniqueValues(o, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = o.options.getFacetedMinMaxValues && o.options.getFacetedMinMaxValues(o, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Ie = (e, o, t) => {
  var n, r;
  const i = t == null || (n = t.toString()) == null ? void 0 : n.toLowerCase();
  return !!(!((r = e.getValue(o)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
Ie.autoRemove = (e) => y(e);
const De = (e, o, t) => {
  var n;
  return !!(!((n = e.getValue(o)) == null || (n = n.toString()) == null) && n.includes(t));
};
De.autoRemove = (e) => y(e);
const He = (e, o, t) => {
  var n;
  return ((n = e.getValue(o)) == null || (n = n.toString()) == null ? void 0 : n.toLowerCase()) === t?.toLowerCase();
};
He.autoRemove = (e) => y(e);
const Ee = (e, o, t) => {
  var n;
  return (n = e.getValue(o)) == null ? void 0 : n.includes(t);
};
Ee.autoRemove = (e) => y(e);
const Ae = (e, o, t) => !t.some((n) => {
  var r;
  return !((r = e.getValue(o)) != null && r.includes(n));
});
Ae.autoRemove = (e) => y(e) || !(e != null && e.length);
const Ge = (e, o, t) => t.some((n) => {
  var r;
  return (r = e.getValue(o)) == null ? void 0 : r.includes(n);
});
Ge.autoRemove = (e) => y(e) || !(e != null && e.length);
const Le = (e, o, t) => e.getValue(o) === t;
Le.autoRemove = (e) => y(e);
const ze = (e, o, t) => e.getValue(o) == t;
ze.autoRemove = (e) => y(e);
const Se = (e, o, t) => {
  let [n, r] = t;
  const i = e.getValue(o);
  return i >= n && i <= r;
};
Se.resolveFilterValue = (e) => {
  let [o, t] = e, n = typeof o != "number" ? parseFloat(o) : o, r = typeof t != "number" ? parseFloat(t) : t, i = o === null || Number.isNaN(n) ? -1 / 0 : n, l = t === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > l) {
    const s = i;
    i = l, l = s;
  }
  return [i, l];
};
Se.autoRemove = (e) => y(e) || y(e[0]) && y(e[1]);
const H = {
  includesString: Ie,
  includesStringSensitive: De,
  equalsString: He,
  arrIncludes: Ee,
  arrIncludesAll: Ae,
  arrIncludesSome: Ge,
  equals: Le,
  weakEquals: ze,
  inNumberRange: Se
};
function y(e) {
  return e == null || e === "";
}
const ut = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: V("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, o) => {
    e.getAutoFilterFn = () => {
      const t = o.getCoreRowModel().flatRows[0], n = t?.getValue(e.id);
      return typeof n == "string" ? H.includesString : typeof n == "number" ? H.inNumberRange : typeof n == "boolean" || n !== null && typeof n == "object" ? H.equals : Array.isArray(n) ? H.arrIncludes : H.weakEquals;
    }, e.getFilterFn = () => {
      var t, n;
      return Q(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (n = o.options.filterFns) == null ? void 0 : n[e.columnDef.filterFn]) != null ? t : H[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, n, r;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((n = o.options.enableColumnFilters) != null ? n : !0) && ((r = o.options.enableFilters) != null ? r : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = o.getState().columnFilters) == null || (t = t.find((n) => n.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, n;
      return (t = (n = o.getState().columnFilters) == null ? void 0 : n.findIndex((r) => r.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      o.setColumnFilters((n) => {
        const r = e.getFilterFn(), i = n?.find((d) => d.id === e.id), l = G(t, i ? i.value : void 0);
        if (xe(r, l, e)) {
          var s;
          return (s = n?.filter((d) => d.id !== e.id)) != null ? s : [];
        }
        const u = {
          id: e.id,
          value: l
        };
        if (i) {
          var a;
          return (a = n?.map((d) => d.id === e.id ? u : d)) != null ? a : [];
        }
        return n != null && n.length ? [...n, u] : [u];
      });
    };
  },
  createRow: (e, o) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (o) => {
      const t = e.getAllLeafColumns(), n = (r) => {
        var i;
        return (i = G(o, r)) == null ? void 0 : i.filter((l) => {
          const s = t.find((u) => u.id === l.id);
          if (s) {
            const u = s.getFilterFn();
            if (xe(u, l.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(n);
    }, e.resetColumnFilters = (o) => {
      var t, n;
      e.setColumnFilters(o ? [] : (t = (n = e.initialState) == null ? void 0 : n.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function xe(e, o, t) {
  return (e && e.autoRemove ? e.autoRemove(o, t) : !1) || typeof o > "u" || typeof o == "string" && !o;
}
const at = (e, o, t) => t.reduce((n, r) => {
  const i = r.getValue(e);
  return n + (typeof i == "number" ? i : 0);
}, 0), gt = (e, o, t) => {
  let n;
  return t.forEach((r) => {
    const i = r.getValue(e);
    i != null && (n > i || n === void 0 && i >= i) && (n = i);
  }), n;
}, dt = (e, o, t) => {
  let n;
  return t.forEach((r) => {
    const i = r.getValue(e);
    i != null && (n < i || n === void 0 && i >= i) && (n = i);
  }), n;
}, ct = (e, o, t) => {
  let n, r;
  return t.forEach((i) => {
    const l = i.getValue(e);
    l != null && (n === void 0 ? l >= l && (n = r = l) : (n > l && (n = l), r < l && (r = l)));
  }), [n, r];
}, ft = (e, o) => {
  let t = 0, n = 0;
  if (o.forEach((r) => {
    let i = r.getValue(e);
    i != null && (i = +i) >= i && (++t, n += i);
  }), t) return n / t;
}, pt = (e, o) => {
  if (!o.length)
    return;
  const t = o.map((i) => i.getValue(e));
  if (!tt(t))
    return;
  if (t.length === 1)
    return t[0];
  const n = Math.floor(t.length / 2), r = t.sort((i, l) => i - l);
  return t.length % 2 !== 0 ? r[n] : (r[n - 1] + r[n]) / 2;
}, mt = (e, o) => Array.from(new Set(o.map((t) => t.getValue(e))).values()), St = (e, o) => new Set(o.map((t) => t.getValue(e))).size, Ct = (e, o) => o.length, b = {
  sum: at,
  min: gt,
  max: dt,
  extent: ct,
  mean: ft,
  median: pt,
  unique: mt,
  uniqueCount: St,
  count: Ct
}, Rt = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var o, t;
      return (o = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? o : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: V("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, o) => {
    e.toggleGrouping = () => {
      o.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((n) => n !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, n;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((n = o.options.enableGrouping) != null ? n : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = o.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = o.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = o.getCoreRowModel().flatRows[0], n = t?.getValue(e.id);
      if (typeof n == "number")
        return b.sum;
      if (Object.prototype.toString.call(n) === "[object Date]")
        return b.extent;
    }, e.getAggregationFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Q(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (n = o.options.aggregationFns) == null ? void 0 : n[e.columnDef.aggregationFn]) != null ? t : b[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (o) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(o), e.resetGrouping = (o) => {
      var t, n;
      e.setGrouping(o ? [] : (t = (n = e.initialState) == null ? void 0 : n.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, o) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const n = o.getColumn(t);
      return n != null && n.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = n.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, o, t, n) => {
    e.getIsGrouped = () => o.getIsGrouped() && o.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && o.getIsGrouped(), e.getIsAggregated = () => {
      var r;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((r = t.subRows) != null && r.length);
    };
  }
};
function ht(e, o, t) {
  if (!(o != null && o.length) || !t)
    return e;
  const n = e.filter((i) => !o.includes(i.id));
  return t === "remove" ? n : [...o.map((i) => e.find((l) => l.id === i)).filter(Boolean), ...n];
}
const wt = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: V("columnOrder", e)
  }),
  createColumn: (e, o) => {
    e.getIndex = S((t) => [O(o, t)], (t) => t.findIndex((n) => n.id === e.id), C(o.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var n;
      return ((n = O(o, t)[0]) == null ? void 0 : n.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var n;
      const r = O(o, t);
      return ((n = r[r.length - 1]) == null ? void 0 : n.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (o) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(o), e.resetColumnOrder = (o) => {
      var t;
      e.setColumnOrder(o ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = S(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (o, t, n) => (r) => {
      let i = [];
      if (!(o != null && o.length))
        i = r;
      else {
        const l = [...o], s = [...r];
        for (; s.length && l.length; ) {
          const u = l.shift(), a = s.findIndex((d) => d.id === u);
          a > -1 && i.push(s.splice(a, 1)[0]);
        }
        i = [...i, ...s];
      }
      return ht(i, t, n);
    }, C(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, ee = () => ({
  left: [],
  right: []
}), vt = {
  getInitialState: (e) => ({
    columnPinning: ee(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: V("columnPinning", e)
  }),
  createColumn: (e, o) => {
    e.pin = (t) => {
      const n = e.getLeafColumns().map((r) => r.id).filter(Boolean);
      o.setColumnPinning((r) => {
        var i, l;
        if (t === "right") {
          var s, u;
          return {
            left: ((s = r?.left) != null ? s : []).filter((m) => !(n != null && n.includes(m))),
            right: [...((u = r?.right) != null ? u : []).filter((m) => !(n != null && n.includes(m))), ...n]
          };
        }
        if (t === "left") {
          var a, d;
          return {
            left: [...((a = r?.left) != null ? a : []).filter((m) => !(n != null && n.includes(m))), ...n],
            right: ((d = r?.right) != null ? d : []).filter((m) => !(n != null && n.includes(m)))
          };
        }
        return {
          left: ((i = r?.left) != null ? i : []).filter((m) => !(n != null && n.includes(m))),
          right: ((l = r?.right) != null ? l : []).filter((m) => !(n != null && n.includes(m)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((n) => {
      var r, i, l;
      return ((r = n.columnDef.enablePinning) != null ? r : !0) && ((i = (l = o.options.enableColumnPinning) != null ? l : o.options.enablePinning) != null ? i : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((s) => s.id), {
        left: n,
        right: r
      } = o.getState().columnPinning, i = t.some((s) => n?.includes(s)), l = t.some((s) => r?.includes(s));
      return i ? "left" : l ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const r = e.getIsPinned();
      return r ? (t = (n = o.getState().columnPinning) == null || (n = n[r]) == null ? void 0 : n.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, o) => {
    e.getCenterVisibleCells = S(() => [e._getAllVisibleCells(), o.getState().columnPinning.left, o.getState().columnPinning.right], (t, n, r) => {
      const i = [...n ?? [], ...r ?? []];
      return t.filter((l) => !i.includes(l.column.id));
    }, C(o.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = S(() => [e._getAllVisibleCells(), o.getState().columnPinning.left], (t, n) => (n ?? []).map((i) => t.find((l) => l.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), C(o.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = S(() => [e._getAllVisibleCells(), o.getState().columnPinning.right], (t, n) => (n ?? []).map((i) => t.find((l) => l.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), C(o.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (o) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(o), e.resetColumnPinning = (o) => {
      var t, n;
      return e.setColumnPinning(o ? ee() : (t = (n = e.initialState) == null ? void 0 : n.columnPinning) != null ? t : ee());
    }, e.getIsSomeColumnsPinned = (o) => {
      var t;
      const n = e.getState().columnPinning;
      if (!o) {
        var r, i;
        return !!((r = n.left) != null && r.length || (i = n.right) != null && i.length);
      }
      return !!((t = n[o]) != null && t.length);
    }, e.getLeftLeafColumns = S(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (o, t) => (t ?? []).map((n) => o.find((r) => r.id === n)).filter(Boolean), C(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = S(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (o, t) => (t ?? []).map((n) => o.find((r) => r.id === n)).filter(Boolean), C(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = S(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (o, t, n) => {
      const r = [...t ?? [], ...n ?? []];
      return o.filter((i) => !r.includes(i.id));
    }, C(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function _t(e) {
  return e || (typeof document < "u" ? document : null);
}
const X = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, te = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), Ft = {
  getDefaultColumnDef: () => X,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: te(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: V("columnSizing", e),
    onColumnSizingInfoChange: V("columnSizingInfo", e)
  }),
  createColumn: (e, o) => {
    e.getSize = () => {
      var t, n, r;
      const i = o.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : X.minSize, (n = i ?? e.columnDef.size) != null ? n : X.size), (r = e.columnDef.maxSize) != null ? r : X.maxSize);
    }, e.getStart = S((t) => [t, O(o, t), o.getState().columnSizing], (t, n) => n.slice(0, e.getIndex(t)).reduce((r, i) => r + i.getSize(), 0), C(o.options, "debugColumns", "getStart")), e.getAfter = S((t) => [t, O(o, t), o.getState().columnSizing], (t, n) => n.slice(e.getIndex(t) + 1).reduce((r, i) => r + i.getSize(), 0), C(o.options, "debugColumns", "getAfter")), e.resetSize = () => {
      o.setColumnSizing((t) => {
        let {
          [e.id]: n,
          ...r
        } = t;
        return r;
      });
    }, e.getCanResize = () => {
      var t, n;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((n = o.options.enableColumnResizing) != null ? n : !0);
    }, e.getIsResizing = () => o.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, o) => {
    e.getSize = () => {
      let t = 0;
      const n = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(n);
        else {
          var i;
          t += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return n(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const n = o.getColumn(e.column.id), r = n?.getCanResize();
      return (i) => {
        if (!n || !r || (i.persist == null || i.persist(), ne(i) && i.touches && i.touches.length > 1))
          return;
        const l = e.getSize(), s = e ? e.getLeafHeaders().map((h) => [h.column.id, h.column.getSize()]) : [[n.id, n.getSize()]], u = ne(i) ? Math.round(i.touches[0].clientX) : i.clientX, a = {}, d = (h, v) => {
          typeof v == "number" && (o.setColumnSizingInfo((_) => {
            var M, $;
            const E = o.options.columnResizeDirection === "rtl" ? -1 : 1, j = (v - ((M = _?.startOffset) != null ? M : 0)) * E, B = Math.max(j / (($ = _?.startSize) != null ? $ : 0), -0.999999);
            return _.columnSizingStart.forEach((k) => {
              let [W, q] = k;
              a[W] = Math.round(Math.max(q + q * B, 0) * 100) / 100;
            }), {
              ..._,
              deltaOffset: j,
              deltaPercentage: B
            };
          }), (o.options.columnResizeMode === "onChange" || h === "end") && o.setColumnSizing((_) => ({
            ..._,
            ...a
          })));
        }, m = (h) => d("move", h), c = (h) => {
          d("end", h), o.setColumnSizingInfo((v) => ({
            ...v,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, g = _t(t), f = {
          moveHandler: (h) => m(h.clientX),
          upHandler: (h) => {
            g?.removeEventListener("mousemove", f.moveHandler), g?.removeEventListener("mouseup", f.upHandler), c(h.clientX);
          }
        }, p = {
          moveHandler: (h) => (h.cancelable && (h.preventDefault(), h.stopPropagation()), m(h.touches[0].clientX), !1),
          upHandler: (h) => {
            var v;
            g?.removeEventListener("touchmove", p.moveHandler), g?.removeEventListener("touchend", p.upHandler), h.cancelable && (h.preventDefault(), h.stopPropagation()), c((v = h.touches[0]) == null ? void 0 : v.clientX);
          }
        }, R = $t() ? {
          passive: !1
        } : !1;
        ne(i) ? (g?.addEventListener("touchmove", p.moveHandler, R), g?.addEventListener("touchend", p.upHandler, R)) : (g?.addEventListener("mousemove", f.moveHandler, R), g?.addEventListener("mouseup", f.upHandler, R)), o.setColumnSizingInfo((h) => ({
          ...h,
          startOffset: u,
          startSize: l,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (o) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(o), e.setColumnSizingInfo = (o) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(o), e.resetColumnSizing = (o) => {
      var t;
      e.setColumnSizing(o ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (o) => {
      var t;
      e.setColumnSizingInfo(o ? te() : (t = e.initialState.columnSizingInfo) != null ? t : te());
    }, e.getTotalSize = () => {
      var o, t;
      return (o = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, r) => n + r.getSize(), 0)) != null ? o : 0;
    }, e.getLeftTotalSize = () => {
      var o, t;
      return (o = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, r) => n + r.getSize(), 0)) != null ? o : 0;
    }, e.getCenterTotalSize = () => {
      var o, t;
      return (o = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, r) => n + r.getSize(), 0)) != null ? o : 0;
    }, e.getRightTotalSize = () => {
      var o, t;
      return (o = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, r) => n + r.getSize(), 0)) != null ? o : 0;
    };
  }
};
let J = null;
function $t() {
  if (typeof J == "boolean") return J;
  let e = !1;
  try {
    const o = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, o), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return J = e, J;
}
function ne(e) {
  return e.type === "touchstart";
}
const xt = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: V("columnVisibility", e)
  }),
  createColumn: (e, o) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && o.setColumnVisibility((n) => ({
        ...n,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, n;
      const r = e.columns;
      return (t = r.length ? r.some((i) => i.getIsVisible()) : (n = o.getState().columnVisibility) == null ? void 0 : n[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, n;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((n = o.options.enableHiding) != null ? n : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, o) => {
    e._getAllVisibleCells = S(() => [e.getAllCells(), o.getState().columnVisibility], (t) => t.filter((n) => n.column.getIsVisible()), C(o.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = S(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, n, r) => [...t, ...n, ...r], C(o.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const o = (t, n) => S(() => [n(), n().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), C(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = o("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = o("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = o("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = o("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = o("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var n;
      e.setColumnVisibility(t ? {} : (n = e.initialState.columnVisibility) != null ? n : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var n;
      t = (n = t) != null ? n : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: t || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var n;
      e.toggleAllColumnsVisible((n = t.target) == null ? void 0 : n.checked);
    };
  }
};
function O(e, o) {
  return o ? o === "center" ? e.getCenterVisibleLeafColumns() : o === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Vt = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, Mt = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: V("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (o) => {
      var t;
      const n = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[o.id]) == null ? void 0 : t.getValue();
      return typeof n == "string" || typeof n == "number";
    }
  }),
  createColumn: (e, o) => {
    e.getCanGlobalFilter = () => {
      var t, n, r, i;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((n = o.options.enableGlobalFilter) != null ? n : !0) && ((r = o.options.enableFilters) != null ? r : !0) && ((i = o.options.getColumnCanGlobalFilter == null ? void 0 : o.options.getColumnCanGlobalFilter(e)) != null ? i : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => H.includesString, e.getGlobalFilterFn = () => {
      var o, t;
      const {
        globalFilterFn: n
      } = e.options;
      return Q(n) ? n : n === "auto" ? e.getGlobalAutoFilterFn() : (o = (t = e.options.filterFns) == null ? void 0 : t[n]) != null ? o : H[n];
    }, e.setGlobalFilter = (o) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(o);
    }, e.resetGlobalFilter = (o) => {
      e.setGlobalFilter(o ? void 0 : e.initialState.globalFilter);
    };
  }
}, yt = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: V("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let o = !1, t = !1;
    e._autoResetExpanded = () => {
      var n, r;
      if (!o) {
        e._queue(() => {
          o = !0;
        });
        return;
      }
      if ((n = (r = e.options.autoResetAll) != null ? r : e.options.autoResetExpanded) != null ? n : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (n) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(n), e.toggleAllRowsExpanded = (n) => {
      n ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (n) => {
      var r, i;
      e.setExpanded(n ? {} : (r = (i = e.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((n) => n.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (n) => {
      n.persist == null || n.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const n = e.getState().expanded;
      return n === !0 || Object.values(n).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const n = e.getState().expanded;
      return typeof n == "boolean" ? n === !0 : !(!Object.keys(n).length || e.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let n = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((i) => {
        const l = i.split(".");
        n = Math.max(n, l.length);
      }), n;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, o) => {
    e.toggleExpanded = (t) => {
      o.setExpanded((n) => {
        var r;
        const i = n === !0 ? !0 : !!(n != null && n[e.id]);
        let l = {};
        if (n === !0 ? Object.keys(o.getRowModel().rowsById).forEach((s) => {
          l[s] = !0;
        }) : l = n, t = (r = t) != null ? r : !i, !i && t)
          return {
            ...l,
            [e.id]: !0
          };
        if (i && !t) {
          const {
            [e.id]: s,
            ...u
          } = l;
          return u;
        }
        return n;
      });
    }, e.getIsExpanded = () => {
      var t;
      const n = o.getState().expanded;
      return !!((t = o.options.getIsRowExpanded == null ? void 0 : o.options.getIsRowExpanded(e)) != null ? t : n === !0 || n?.[e.id]);
    }, e.getCanExpand = () => {
      var t, n, r;
      return (t = o.options.getRowCanExpand == null ? void 0 : o.options.getRowCanExpand(e)) != null ? t : ((n = o.options.enableExpanding) != null ? n : !0) && !!((r = e.subRows) != null && r.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, n = e;
      for (; t && n.parentId; )
        n = o.getRow(n.parentId, !0), t = n.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, le = 0, se = 10, oe = () => ({
  pageIndex: le,
  pageSize: se
}), Pt = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...oe(),
      ...e?.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: V("pagination", e)
  }),
  createTable: (e) => {
    let o = !1, t = !1;
    e._autoResetPageIndex = () => {
      var n, r;
      if (!o) {
        e._queue(() => {
          o = !0;
        });
        return;
      }
      if ((n = (r = e.options.autoResetAll) != null ? r : e.options.autoResetPageIndex) != null ? n : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (n) => {
      const r = (i) => G(n, i);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(r);
    }, e.resetPagination = (n) => {
      var r;
      e.setPagination(n ? oe() : (r = e.initialState.pagination) != null ? r : oe());
    }, e.setPageIndex = (n) => {
      e.setPagination((r) => {
        let i = G(n, r.pageIndex);
        const l = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, l)), {
          ...r,
          pageIndex: i
        };
      });
    }, e.resetPageIndex = (n) => {
      var r, i;
      e.setPageIndex(n ? le : (r = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : le);
    }, e.resetPageSize = (n) => {
      var r, i;
      e.setPageSize(n ? se : (r = (i = e.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : se);
    }, e.setPageSize = (n) => {
      e.setPagination((r) => {
        const i = Math.max(1, G(n, r.pageSize)), l = r.pageSize * r.pageIndex, s = Math.floor(l / i);
        return {
          ...r,
          pageIndex: s,
          pageSize: i
        };
      });
    }, e.setPageCount = (n) => e.setPagination((r) => {
      var i;
      let l = G(n, (i = e.options.pageCount) != null ? i : -1);
      return typeof l == "number" && (l = Math.max(-1, l)), {
        ...r,
        pageCount: l
      };
    }), e.getPageOptions = S(() => [e.getPageCount()], (n) => {
      let r = [];
      return n && n > 0 && (r = [...new Array(n)].fill(null).map((i, l) => l)), r;
    }, C(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: n
      } = e.getState().pagination, r = e.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : n < r - 1;
    }, e.previousPage = () => e.setPageIndex((n) => n - 1), e.nextPage = () => e.setPageIndex((n) => n + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var n;
      return (n = e.options.pageCount) != null ? n : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var n;
      return (n = e.options.rowCount) != null ? n : e.getPrePaginationRowModel().rows.length;
    };
  }
}, re = () => ({
  top: [],
  bottom: []
}), It = {
  getInitialState: (e) => ({
    rowPinning: re(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: V("rowPinning", e)
  }),
  createRow: (e, o) => {
    e.pin = (t, n, r) => {
      const i = n ? e.getLeafRows().map((u) => {
        let {
          id: a
        } = u;
        return a;
      }) : [], l = r ? e.getParentRows().map((u) => {
        let {
          id: a
        } = u;
        return a;
      }) : [], s = /* @__PURE__ */ new Set([...l, e.id, ...i]);
      o.setRowPinning((u) => {
        var a, d;
        if (t === "bottom") {
          var m, c;
          return {
            top: ((m = u?.top) != null ? m : []).filter((p) => !(s != null && s.has(p))),
            bottom: [...((c = u?.bottom) != null ? c : []).filter((p) => !(s != null && s.has(p))), ...Array.from(s)]
          };
        }
        if (t === "top") {
          var g, f;
          return {
            top: [...((g = u?.top) != null ? g : []).filter((p) => !(s != null && s.has(p))), ...Array.from(s)],
            bottom: ((f = u?.bottom) != null ? f : []).filter((p) => !(s != null && s.has(p)))
          };
        }
        return {
          top: ((a = u?.top) != null ? a : []).filter((p) => !(s != null && s.has(p))),
          bottom: ((d = u?.bottom) != null ? d : []).filter((p) => !(s != null && s.has(p)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: n,
        enablePinning: r
      } = o.options;
      return typeof n == "function" ? n(e) : (t = n ?? r) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: n,
        bottom: r
      } = o.getState().rowPinning, i = t.some((s) => n?.includes(s)), l = t.some((s) => r?.includes(s));
      return i ? "top" : l ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const r = e.getIsPinned();
      if (!r) return -1;
      const i = (t = r === "top" ? o.getTopRows() : o.getBottomRows()) == null ? void 0 : t.map((l) => {
        let {
          id: s
        } = l;
        return s;
      });
      return (n = i?.indexOf(e.id)) != null ? n : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (o) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(o), e.resetRowPinning = (o) => {
      var t, n;
      return e.setRowPinning(o ? re() : (t = (n = e.initialState) == null ? void 0 : n.rowPinning) != null ? t : re());
    }, e.getIsSomeRowsPinned = (o) => {
      var t;
      const n = e.getState().rowPinning;
      if (!o) {
        var r, i;
        return !!((r = n.top) != null && r.length || (i = n.bottom) != null && i.length);
      }
      return !!((t = n[o]) != null && t.length);
    }, e._getPinnedRows = (o, t, n) => {
      var r;
      return ((r = e.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((l) => {
          const s = e.getRow(l, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((l) => o.find((s) => s.id === l))
      )).filter(Boolean).map((l) => ({
        ...l,
        position: n
      }));
    }, e.getTopRows = S(() => [e.getRowModel().rows, e.getState().rowPinning.top], (o, t) => e._getPinnedRows(o, t, "top"), C(e.options, "debugRows", "getTopRows")), e.getBottomRows = S(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (o, t) => e._getPinnedRows(o, t, "bottom"), C(e.options, "debugRows", "getBottomRows")), e.getCenterRows = S(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (o, t, n) => {
      const r = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
      return o.filter((i) => !r.has(i.id));
    }, C(e.options, "debugRows", "getCenterRows"));
  }
}, Dt = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: V("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (o) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(o), e.resetRowSelection = (o) => {
      var t;
      return e.setRowSelection(o ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (o) => {
      e.setRowSelection((t) => {
        o = typeof o < "u" ? o : !e.getIsAllRowsSelected();
        const n = {
          ...t
        }, r = e.getPreGroupedRowModel().flatRows;
        return o ? r.forEach((i) => {
          i.getCanSelect() && (n[i.id] = !0);
        }) : r.forEach((i) => {
          delete n[i.id];
        }), n;
      });
    }, e.toggleAllPageRowsSelected = (o) => e.setRowSelection((t) => {
      const n = typeof o < "u" ? o : !e.getIsAllPageRowsSelected(), r = {
        ...t
      };
      return e.getRowModel().rows.forEach((i) => {
        ue(r, i.id, n, !0, e);
      }), r;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = S(() => [e.getState().rowSelection, e.getCoreRowModel()], (o, t) => Object.keys(o).length ? ie(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, C(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = S(() => [e.getState().rowSelection, e.getFilteredRowModel()], (o, t) => Object.keys(o).length ? ie(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, C(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = S(() => [e.getState().rowSelection, e.getSortedRowModel()], (o, t) => Object.keys(o).length ? ie(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, C(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const o = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let n = !!(o.length && Object.keys(t).length);
      return n && o.some((r) => r.getCanSelect() && !t[r.id]) && (n = !1), n;
    }, e.getIsAllPageRowsSelected = () => {
      const o = e.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let n = !!o.length;
      return n && o.some((r) => !t[r.id]) && (n = !1), n;
    }, e.getIsSomeRowsSelected = () => {
      var o;
      const t = Object.keys((o = e.getState().rowSelection) != null ? o : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const o = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : o.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (o) => {
      e.toggleAllRowsSelected(o.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (o) => {
      e.toggleAllPageRowsSelected(o.target.checked);
    };
  },
  createRow: (e, o) => {
    e.toggleSelected = (t, n) => {
      const r = e.getIsSelected();
      o.setRowSelection((i) => {
        var l;
        if (t = typeof t < "u" ? t : !r, e.getCanSelect() && r === t)
          return i;
        const s = {
          ...i
        };
        return ue(s, e.id, t, (l = n?.selectChildren) != null ? l : !0, o), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = o.getState();
      return Ce(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = o.getState();
      return ae(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = o.getState();
      return ae(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof o.options.enableRowSelection == "function" ? o.options.enableRowSelection(e) : (t = o.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof o.options.enableSubRowSelection == "function" ? o.options.enableSubRowSelection(e) : (t = o.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof o.options.enableMultiRowSelection == "function" ? o.options.enableMultiRowSelection(e) : (t = o.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (n) => {
        var r;
        t && e.toggleSelected((r = n.target) == null ? void 0 : r.checked);
      };
    };
  }
}, ue = (e, o, t, n, r) => {
  var i;
  const l = r.getRow(o, !0);
  t ? (l.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), l.getCanSelect() && (e[o] = !0)) : delete e[o], n && (i = l.subRows) != null && i.length && l.getCanSelectSubRows() && l.subRows.forEach((s) => ue(e, s.id, t, n, r));
};
function ie(e, o) {
  const t = e.getState().rowSelection, n = [], r = {}, i = function(l, s) {
    return l.map((u) => {
      var a;
      const d = Ce(u, t);
      if (d && (n.push(u), r[u.id] = u), (a = u.subRows) != null && a.length && (u = {
        ...u,
        subRows: i(u.subRows)
      }), d)
        return u;
    }).filter(Boolean);
  };
  return {
    rows: i(o.rows),
    flatRows: n,
    rowsById: r
  };
}
function Ce(e, o) {
  var t;
  return (t = o[e.id]) != null ? t : !1;
}
function ae(e, o, t) {
  var n;
  if (!((n = e.subRows) != null && n.length)) return !1;
  let r = !0, i = !1;
  return e.subRows.forEach((l) => {
    if (!(i && !r) && (l.getCanSelect() && (Ce(l, o) ? i = !0 : r = !1), l.subRows && l.subRows.length)) {
      const s = ae(l, o);
      s === "all" ? i = !0 : (s === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const ge = /([0-9]+)/gm, Ht = (e, o, t) => Oe(L(e.getValue(t)).toLowerCase(), L(o.getValue(t)).toLowerCase()), Et = (e, o, t) => Oe(L(e.getValue(t)), L(o.getValue(t))), At = (e, o, t) => Re(L(e.getValue(t)).toLowerCase(), L(o.getValue(t)).toLowerCase()), Gt = (e, o, t) => Re(L(e.getValue(t)), L(o.getValue(t))), Lt = (e, o, t) => {
  const n = e.getValue(t), r = o.getValue(t);
  return n > r ? 1 : n < r ? -1 : 0;
}, zt = (e, o, t) => Re(e.getValue(t), o.getValue(t));
function Re(e, o) {
  return e === o ? 0 : e > o ? 1 : -1;
}
function L(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Oe(e, o) {
  const t = e.split(ge).filter(Boolean), n = o.split(ge).filter(Boolean);
  for (; t.length && n.length; ) {
    const r = t.shift(), i = n.shift(), l = parseInt(r, 10), s = parseInt(i, 10), u = [l, s].sort();
    if (isNaN(u[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(u[1]))
      return isNaN(l) ? -1 : 1;
    if (l > s)
      return 1;
    if (s > l)
      return -1;
  }
  return t.length - n.length;
}
const z = {
  alphanumeric: Ht,
  alphanumericCaseSensitive: Et,
  text: At,
  textCaseSensitive: Gt,
  datetime: Lt,
  basic: zt
}, Ot = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: V("sorting", e),
    isMultiSortEvent: (o) => o.shiftKey
  }),
  createColumn: (e, o) => {
    e.getAutoSortingFn = () => {
      const t = o.getFilteredRowModel().flatRows.slice(10);
      let n = !1;
      for (const r of t) {
        const i = r?.getValue(e.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return z.datetime;
        if (typeof i == "string" && (n = !0, i.split(ge).length > 1))
          return z.alphanumeric;
      }
      return n ? z.text : z.basic;
    }, e.getAutoSortDir = () => {
      const t = o.getFilteredRowModel().flatRows[0];
      return typeof t?.getValue(e.id) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Q(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (n = o.options.sortingFns) == null ? void 0 : n[e.columnDef.sortingFn]) != null ? t : z[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, n) => {
      const r = e.getNextSortingOrder(), i = typeof t < "u" && t !== null;
      o.setSorting((l) => {
        const s = l?.find((g) => g.id === e.id), u = l?.findIndex((g) => g.id === e.id);
        let a = [], d, m = i ? t : r === "desc";
        if (l != null && l.length && e.getCanMultiSort() && n ? s ? d = "toggle" : d = "add" : l != null && l.length && u !== l.length - 1 ? d = "replace" : s ? d = "toggle" : d = "replace", d === "toggle" && (i || r || (d = "remove")), d === "add") {
          var c;
          a = [...l, {
            id: e.id,
            desc: m
          }], a.splice(0, a.length - ((c = o.options.maxMultiSortColCount) != null ? c : Number.MAX_SAFE_INTEGER));
        } else d === "toggle" ? a = l.map((g) => g.id === e.id ? {
          ...g,
          desc: m
        } : g) : d === "remove" ? a = l.filter((g) => g.id !== e.id) : a = [{
          id: e.id,
          desc: m
        }];
        return a;
      });
    }, e.getFirstSortDir = () => {
      var t, n;
      return ((t = (n = e.columnDef.sortDescFirst) != null ? n : o.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var n, r;
      const i = e.getFirstSortDir(), l = e.getIsSorted();
      return l ? l !== i && ((n = o.options.enableSortingRemoval) == null || n) && // If enableSortRemove, enable in general
      (!(t && (r = o.options.enableMultiRemove) != null) || r) ? !1 : l === "desc" ? "asc" : "desc" : i;
    }, e.getCanSort = () => {
      var t, n;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((n = o.options.enableSorting) != null ? n : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, n;
      return (t = (n = e.columnDef.enableMultiSort) != null ? n : o.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const n = (t = o.getState().sorting) == null ? void 0 : t.find((r) => r.id === e.id);
      return n ? n.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, n;
      return (t = (n = o.getState().sorting) == null ? void 0 : n.findIndex((r) => r.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      o.setSorting((t) => t != null && t.length ? t.filter((n) => n.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (n) => {
        t && (n.persist == null || n.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? o.options.isMultiSortEvent == null ? void 0 : o.options.isMultiSortEvent(n) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (o) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(o), e.resetSorting = (o) => {
      var t, n;
      e.setSorting(o ? [] : (t = (n = e.initialState) == null ? void 0 : n.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Nt = [
  it,
  xt,
  wt,
  vt,
  st,
  ut,
  Vt,
  //depends on ColumnFaceting
  Mt,
  //depends on ColumnFiltering
  Ot,
  Rt,
  //depends on RowSorting
  yt,
  Pt,
  It,
  Dt,
  Ft
];
function Tt(e) {
  var o, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const n = [...Nt, ...(o = e._features) != null ? o : []];
  let r = {
    _features: n
  };
  const i = r._features.reduce((c, g) => Object.assign(c, g.getDefaultOptions == null ? void 0 : g.getDefaultOptions(r)), {}), l = (c) => r.options.mergeOptions ? r.options.mergeOptions(i, c) : {
    ...i,
    ...c
  };
  let u = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  r._features.forEach((c) => {
    var g;
    u = (g = c.getInitialState == null ? void 0 : c.getInitialState(u)) != null ? g : u;
  });
  const a = [];
  let d = !1;
  const m = {
    _features: n,
    options: {
      ...i,
      ...e
    },
    initialState: u,
    _queue: (c) => {
      a.push(c), d || (d = !0, Promise.resolve().then(() => {
        for (; a.length; )
          a.shift()();
        d = !1;
      }).catch((g) => setTimeout(() => {
        throw g;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (c) => {
      const g = G(c, r.options);
      r.options = l(g);
    },
    getState: () => r.options.state,
    setState: (c) => {
      r.options.onStateChange == null || r.options.onStateChange(c);
    },
    _getRowId: (c, g, f) => {
      var p;
      return (p = r.options.getRowId == null ? void 0 : r.options.getRowId(c, g, f)) != null ? p : `${f ? [f.id, g].join(".") : g}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (c, g) => {
      let f = (g ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[c];
      if (!f && (f = r.getCoreRowModel().rowsById[c], !f))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${c}`) : new Error();
      return f;
    },
    _getDefaultColumnDef: S(() => [r.options.defaultColumn], (c) => {
      var g;
      return c = (g = c) != null ? g : {}, {
        header: (f) => {
          const p = f.header.column.columnDef;
          return p.accessorKey ? p.accessorKey : p.accessorFn ? p.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (f) => {
          var p, R;
          return (p = (R = f.renderValue()) == null || R.toString == null ? void 0 : R.toString()) != null ? p : null;
        },
        ...r._features.reduce((f, p) => Object.assign(f, p.getDefaultColumnDef == null ? void 0 : p.getDefaultColumnDef()), {}),
        ...c
      };
    }, C(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: S(() => [r._getColumnDefs()], (c) => {
      const g = function(f, p, R) {
        return R === void 0 && (R = 0), f.map((h) => {
          const v = rt(r, h, R, p), _ = h;
          return v.columns = _.columns ? g(_.columns, v, R + 1) : [], v;
        });
      };
      return g(c);
    }, C(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: S(() => [r.getAllColumns()], (c) => c.flatMap((g) => g.getFlatColumns()), C(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: S(() => [r.getAllFlatColumns()], (c) => c.reduce((g, f) => (g[f.id] = f, g), {}), C(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: S(() => [r.getAllColumns(), r._getOrderColumnsFn()], (c, g) => {
      let f = c.flatMap((p) => p.getLeafColumns());
      return g(f);
    }, C(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (c) => {
      const g = r._getAllFlatColumnsById()[c];
      return process.env.NODE_ENV !== "production" && !g && console.error(`[Table] Column with id '${c}' does not exist.`), g;
    }
  };
  Object.assign(r, m);
  for (let c = 0; c < r._features.length; c++) {
    const g = r._features[c];
    g == null || g.createTable == null || g.createTable(r);
  }
  return r;
}
function jt() {
  return (e) => S(() => [e.options.data], (o) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, n = function(r, i, l) {
      i === void 0 && (i = 0);
      const s = [];
      for (let a = 0; a < r.length; a++) {
        const d = lt(e, e._getRowId(r[a], a, l), r[a], a, i, void 0, l?.id);
        if (t.flatRows.push(d), t.rowsById[d.id] = d, s.push(d), e.options.getSubRows) {
          var u;
          d.originalSubRows = e.options.getSubRows(r[a], a), (u = d.originalSubRows) != null && u.length && (d.subRows = n(d.originalSubRows, i + 1, d));
        }
      }
      return s;
    };
    return t.rows = n(o), t;
  }, C(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Bt() {
  return (e) => S(() => [e.getState().sorting, e.getPreSortedRowModel()], (o, t) => {
    if (!t.rows.length || !(o != null && o.length))
      return t;
    const n = e.getState().sorting, r = [], i = n.filter((u) => {
      var a;
      return (a = e.getColumn(u.id)) == null ? void 0 : a.getCanSort();
    }), l = {};
    i.forEach((u) => {
      const a = e.getColumn(u.id);
      a && (l[u.id] = {
        sortUndefined: a.columnDef.sortUndefined,
        invertSorting: a.columnDef.invertSorting,
        sortingFn: a.getSortingFn()
      });
    });
    const s = (u) => {
      const a = u.map((d) => ({
        ...d
      }));
      return a.sort((d, m) => {
        for (let g = 0; g < i.length; g += 1) {
          var c;
          const f = i[g], p = l[f.id], R = p.sortUndefined, h = (c = f?.desc) != null ? c : !1;
          let v = 0;
          if (R) {
            const _ = d.getValue(f.id), M = m.getValue(f.id), $ = _ === void 0, E = M === void 0;
            if ($ || E) {
              if (R === "first") return $ ? -1 : 1;
              if (R === "last") return $ ? 1 : -1;
              v = $ && E ? 0 : $ ? R : -R;
            }
          }
          if (v === 0 && (v = p.sortingFn(d, m, f.id)), v !== 0)
            return h && (v *= -1), p.invertSorting && (v *= -1), v;
        }
        return d.index - m.index;
      }), a.forEach((d) => {
        var m;
        r.push(d), (m = d.subRows) != null && m.length && (d.subRows = s(d.subRows));
      }), a;
    };
    return {
      rows: s(t.rows),
      flatRows: r,
      rowsById: t.rowsById
    };
  }, C(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
function Ne(e, o) {
  return e ? kt(e) ? /* @__PURE__ */ P.createElement(e, o) : e : null;
}
function kt(e) {
  return qt(e) || typeof e == "function" || Ut(e);
}
function qt(e) {
  return typeof e == "function" && (() => {
    const o = Object.getPrototypeOf(e);
    return o.prototype && o.prototype.isReactComponent;
  })();
}
function Ut(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function Kt(e) {
  const o = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = P.useState(() => ({
    current: Tt(o)
  })), [n, r] = P.useState(() => t.current.initialState);
  return t.current.setOptions((i) => ({
    ...i,
    ...e,
    state: {
      ...n,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (l) => {
      r(l), e.onStateChange == null || e.onStateChange(l);
    }
  })), t.current;
}
const Te = (e) => {
  const o = et();
  return e.map((n) => n.columns && n.columns.length > 0 ? o.group({
    header: n.header,
    columns: Te(n.columns),
    footer: (r) => r.column.id
  }) : o.accessor(n?.accessorKey || n.header, {
    header: n.header,
    footer: (r) => r.column.id,
    enableSorting: n.enableSorting
  }));
}, Xt = ({ header: e, columns: o }) => {
  const t = e.column.columnDef, n = !!(t.columns && t.columns.length > 0), r = n && o.find((u) => u.accessorKey === t.accessorKey)?.highlighted, i = o.find(
    (u) => u.columns?.some((a) => a.accessorKey === t.accessorKey)
  ), l = i?.columns?.[0].accessorKey === t.accessorKey, s = i?.columns?.[i.columns.length - 1].accessorKey === t.accessorKey;
  return /* @__PURE__ */ w.jsx(
    pe,
    {
      className: x(
        ye({
          empty: e.isPlaceholder,
          parent: n,
          highlighted: r,
          first: !n && l,
          last: !n && s
        })
      ),
      colSpan: e.colSpan,
      onClick: n ? void 0 : e.column.getToggleSortingHandler(),
      children: e.isPlaceholder ? null : /* @__PURE__ */ w.jsxs("span", { children: [
        /* @__PURE__ */ w.jsx(qe, { children: Ne(e.column.columnDef.header, e.getContext()) }),
        e.column.getCanSort() && !n && e.column.getIsSorted() === !1 && /* @__PURE__ */ w.jsx(
          We,
          {
            className: x(
              Z({
                isSorted: !1
              })
            ),
            size: 16
          }
        ),
        e.column.getCanSort() && !n && e.column.getIsSorted() === "asc" && /* @__PURE__ */ w.jsx(
          Ke,
          {
            className: x(
              Z({
                isSorted: !0
              })
            ),
            size: 16
          }
        ),
        e.column.getCanSort() && !n && e.column.getIsSorted() === "desc" && /* @__PURE__ */ w.jsx(
          Xe,
          {
            className: x(
              Z({
                isSorted: !0
              })
            ),
            size: 16
          }
        )
      ] })
    },
    e.id
  );
}, un = ({
  columns: e,
  rows: o,
  caption: t,
  onSortingChange: n,
  sortState: r,
  manualSorting: i = !1,
  isLoading: l = !1,
  rowPinningState: s,
  onRowPinningChange: u,
  scrollShadowConfig: a,
  onRowSelectionChange: d,
  enableRowSelection: m = !1,
  rowSelectionState: c,
  ...g
}) => {
  const [f, p] = Y(r || []), [R, h] = Y(s || {}), [v] = Y(c || {}), _ = ve(() => Te(e), [e]), M = e.some((D) => D.enableSorting), { isMobile: $ } = ke(), E = _e(
    (D) => {
      const I = D(f);
      p(I), n?.(I);
    },
    [f, n]
  ), j = _e(
    (D) => {
      const I = D(R);
      h(I), u?.(I);
    },
    [R, u]
  ), B = ve(
    () => ({ sorting: f, rowPinning: R, rowSelection: v }),
    [f, R, v]
  ), k = Kt({
    data: o,
    columns: _,
    getCoreRowModel: jt(),
    getSortedRowModel: Bt(),
    manualSorting: i,
    enableMultiSort: !1,
    onSortingChange: E,
    onRowPinningChange: j,
    enableRowSelection: m,
    getRowId: (D) => D.id,
    state: B
  }), W = $ ? "" : "h-[90vh]", q = R?.top?.length ? W : "", je = R?.top?.length ? "sticky top-0 z-1 shadow-md" : "";
  return /* @__PURE__ */ w.jsx(Je, { scrollShadowConfig: a, recalculateDependency: o.length, children: (D) => /* @__PURE__ */ w.jsx(
    Ve,
    {
      ref: D,
      className: x(
        "overflow-x-scroll rounded-lg",
        q,
        l && "opacity-70 pointer-events-none"
      ),
      "data-testid": "table-container",
      children: /* @__PURE__ */ w.jsxs(de, { className: x(Me({ sortable: M })), ...g, children: [
        t && /* @__PURE__ */ w.jsx("caption", { className: "sr-only", children: t }),
        /* @__PURE__ */ w.jsx(ce, { className: je, children: k.getHeaderGroups().map((A) => /* @__PURE__ */ w.jsx(N, { children: A.headers.map((I) => /* @__PURE__ */ w.jsx(Xt, { header: I, columns: e }, I.id)) }, A.id)) }),
        /* @__PURE__ */ w.jsx(fe, { children: k.getRowModel().rows.map((A) => {
          const I = A.getVisibleCells(), he = {};
          return A.getIsSelected() && (he["data-state"] = "selected"), /* @__PURE__ */ w.jsx(N, { ...he, children: I.map((U) => {
            const we = U.getValue();
            return /* @__PURE__ */ w.jsx(
              me,
              {
                className: x(Pe(), "kraken-table-cell"),
                children: Be(we) ? we : Ne(U.column.columnDef.cell, U.getContext())
              },
              U.id
            );
          }) }, A.id);
        }) })
      ] })
    }
  ) });
}, an = ({ rows: e = 3, cols: o = 4, ...t }) => /* @__PURE__ */ w.jsx(Ve, { className: be({ loading: !0 }), "data-testid": "table-skeleton-container", children: /* @__PURE__ */ w.jsxs(de, { className: Me(), ...t, children: [
  /* @__PURE__ */ w.jsx(ce, { children: /* @__PURE__ */ w.jsx(N, { children: Array.from({ length: o }).map((n, r) => /* @__PURE__ */ w.jsx(pe, { className: ye(), children: /* @__PURE__ */ w.jsx("span", { children: /* @__PURE__ */ w.jsx(Fe, { className: "h-6 w-24", grayVariant: 300 }) }) }, `header-${r}`)) }) }),
  /* @__PURE__ */ w.jsx(fe, { children: Array.from({ length: e }).map((n, r) => /* @__PURE__ */ w.jsx(N, { children: Array.from({ length: o }).map((i, l) => /* @__PURE__ */ w.jsx(me, { className: Pe(), children: /* @__PURE__ */ w.jsx(Fe, { className: "h-6 w-full", grayVariant: 200 }) }, `cell-${r}-${l}`)) }, `row-${r}`)) })
] }) });
export {
  un as Table,
  an as TableSkeleton
};
